import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cookie, X } from 'lucide-react';
import { Button } from './ui/button';

const COOKIE_CONSENT_KEY = 'prixdeal_cookie_consent';

export const CookieBanner = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
        if (!consent) {
            const timer = setTimeout(() => setVisible(true), 3000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted');
        setVisible(false);
    };

    const handleRefuse = () => {
        localStorage.setItem(COOKIE_CONSENT_KEY, 'refused');
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div className="fixed bottom-0 inset-x-0 z-[100] p-4 sm:p-6 pointer-events-none" data-testid="cookie-banner">
            <div className="max-w-3xl mx-auto bg-jungle text-sand rounded-2xl shadow-2xl border border-white/10 p-5 sm:p-6 pointer-events-auto">
                <div className="flex items-start gap-4">
                    <div className="hidden sm:flex w-10 h-10 rounded-xl bg-leaf/20 items-center justify-center flex-shrink-0 mt-0.5">
                        <Cookie className="w-5 h-5 text-leaf" />
                    </div>
                    <div className="flex-1 min-w-0">
                        <p className="text-sm leading-relaxed text-sand/90">
                            Nous utilisons des <strong>cookies essentiels</strong> pour le bon fonctionnement du site (authentification, panier) et des cookies analytiques pour ameliorer nos services.
                            {' '}
                            <Link to="/politique-confidentialite" className="text-leaf hover:underline font-medium" data-testid="cookie-privacy-link">
                                En savoir plus
                            </Link>
                        </p>
                        <div className="flex flex-wrap gap-3 mt-4">
                            <Button
                                onClick={handleAccept}
                                className="bg-leaf hover:bg-leaf/90 text-jungle font-semibold rounded-xl h-9 px-5 text-sm"
                                data-testid="cookie-accept-btn"
                            >
                                Accepter tout
                            </Button>
                            <Button
                                onClick={handleRefuse}
                                variant="outline"
                                className="border-sand/30 text-sand hover:bg-white/10 rounded-xl h-9 px-5 text-sm"
                                data-testid="cookie-refuse-btn"
                            >
                                Essentiels uniquement
                            </Button>
                        </div>
                    </div>
                    <button
                        onClick={handleRefuse}
                        className="flex-shrink-0 text-sand/50 hover:text-sand transition-colors"
                        data-testid="cookie-close-btn"
                    >
                        <X className="w-5 h-5" />
                    </button>
                </div>
            </div>
        </div>
    );
};
